module.exports = __webpack_public_path__ + "images/fa-practice-exams-lms.jpg";